<template>
  <div>
    <gl-backdrop v-if="backdropVisible" @click="isOpen = false" />
    <div class="container" :class="containerClasses">
      <div class="header" @click="isOpen = !isOpen">
        <span class="count">{{ count }}</span>
        <gl-sub-text> 顧客選択</gl-sub-text>
      </div>
      <div class="body">
        <div class="actions">
          <gl-button @click="$emit('update:customers', [])"
            >Clear All</gl-button
          >
          <gl-button
            :disabled="downloading"
            @click="$emit('download', [...customers])"
          >
            <gl-icon-download v-if="!downloading" />
            <spinner v-else :diameter="14" :stroke="3" />
            顧客一覧をダウンロード
          </gl-button>
          <slot />
        </div>
        <div class="chips">
          <transition-group name="chips" tag="div">
            <gl-chip
              v-for="c in customers"
              :key="c.id"
              @delete="deleteItem(c.id)"
              primary
              deletable
              >{{ c.text }}</gl-chip
            >
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue'

/**
 * 顧客コレクション
 *
 * Events
 * * clear
 * * download
 * * delete
 *
 * Usage
 * <customer-collection v-bind.sync="customerCollectoion" />
 */
export default {
  components: { Spinner },
  props: {
    customers: {
      type: Array,
      default: () => [],
    },
    downloading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  watch: {
    customers(newValue) {
      if (newValue.length === 0) {
        this.isOpen = false
      }
    },
  },
  computed: {
    count() {
      return this.customers.length
    },
    containerClasses() {
      if (this.customers.length === 0) {
        return ['hidden']
      }
      if (!this.isOpen) {
        return ['shrink']
      }
      return ['open']
    },
    backdropVisible() {
      return this.customers.length > 0 && this.isOpen
    },
  },
  methods: {
    deleteItem(id) {
      this.$emit('update:customers', this.customers.filter(c => c.id !== id))
    },
  },
}
</script>

<style lang="scss" scoped>
$container-height: 400px;
$header-height: 40px;
$transition-duration: 250ms;

.container {
  background: var(--bg-color-primary);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  bottom: 0;
  position: fixed;
  right: var(--spacing-medium);
  width: 600px;
  opacity: 0.8;
  transition: transform $transition-duration ease-out,
    opacity $transition-duration ease-out;
  z-index: 1001;

  &.open {
    height: $container-height;
  }
  &.shrink {
    transform: translateY($container-height - $header-height);
  }
  &.hidden {
    transform: translateY($container-height);
  }
  &:hover {
    opacity: 1;
  }
}

.header {
  background: var(--bg-color-accent);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: var(--text-color-accent);
  cursor: pointer;
  height: $header-height;
  line-height: $header-height;
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
}

.body {
  height: $container-height - $header-height;
  overflow-y: auto;
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
  padding-bottom: var(--spacing-medium);

  .actions {
    margin-top: var(--spacing-medium);
    margin-bottom: var(--spacing-small);
    align-items: center;
    display: flex;

    .left {
      flex: 1;
    }

    .clickable {
      cursor: pointer;
    }
  }
}

.count {
  color: #ef5350;
}

.gl-chip {
  margin-left: var(--spacing-small);
  margin-top: var(--spacing-small);
  // For Transition Animation
  display: inline-block;
}

// Chips Animation
.chips-enter,
.chips-leave-to {
  opacity: 0;
}
.chips-leave-active {
  position: absolute;
}
.chips-move {
  transition: transform 0.3s;
}
</style>
